// Číselníky podle docs/SPEC.md část 3. Jediný zdroj pravdy pro web, api i db.
import { z } from 'zod'

export const JOB_STAGES = ['lead', 'quote', 'agreed', 'in_progress', 'done', 'invoiced'] as const
export const jobStageSchema = z.enum(JOB_STAGES)
export type JobStage = z.infer<typeof jobStageSchema>

export const JOB_SOURCES = [
  'manual',
  'voice',
  'web_form',
  'email',
  'call',
  'marketplace',
  'meta_ads',
  'google_ads',
  'referral',
  'other',
] as const
export const jobSourceSchema = z.enum(JOB_SOURCES)
export type JobSource = z.infer<typeof jobSourceSchema>

export const CLIENT_TYPES = ['person', 'company'] as const
export const clientTypeSchema = z.enum(CLIENT_TYPES)
export type ClientType = z.infer<typeof clientTypeSchema>

export const PROMISE_STATUSES = ['open', 'done', 'cancelled'] as const
export const promiseStatusSchema = z.enum(PROMISE_STATUSES)
export type PromiseStatus = z.infer<typeof promiseStatusSchema>

export const TASK_STATUSES = ['open', 'done'] as const
export const taskStatusSchema = z.enum(TASK_STATUSES)
export type TaskStatus = z.infer<typeof taskStatusSchema>

export const EVENT_TYPES = ['visit', 'work', 'meeting', 'other'] as const
export const eventTypeSchema = z.enum(EVENT_TYPES)
export type EventType = z.infer<typeof eventTypeSchema>

export const INTERACTION_TYPES = [
  'voice_note',
  'call',
  'email',
  'sms',
  'whatsapp',
  'note',
  'web_form',
  'telegram',
  'chat',
] as const
export const interactionTypeSchema = z.enum(INTERACTION_TYPES)
export type InteractionType = z.infer<typeof interactionTypeSchema>

export const INTERACTION_DIRECTIONS = ['inbound', 'outbound', 'internal'] as const
export const interactionDirectionSchema = z.enum(INTERACTION_DIRECTIONS)
export type InteractionDirection = z.infer<typeof interactionDirectionSchema>

export const AI_ACTION_TYPES = [
  'create_client',
  'create_job',
  'add_promise',
  'create_event',
  'create_task',
  'update_job_stage',
  'schedule_reminder',
  'draft_message',
] as const
export const aiActionTypeSchema = z.enum(AI_ACTION_TYPES)
export type AiActionType = z.infer<typeof aiActionTypeSchema>

export const AI_ACTION_STATUSES = ['proposed', 'approved', 'rejected', 'auto', 'undone'] as const
export const aiActionStatusSchema = z.enum(AI_ACTION_STATUSES)
export type AiActionStatus = z.infer<typeof aiActionStatusSchema>

export const REMINDER_CHANNELS = ['push', 'email', 'sms'] as const
export const reminderChannelSchema = z.enum(REMINDER_CHANNELS)
export type ReminderChannel = z.infer<typeof reminderChannelSchema>

export const REMINDER_STATUSES = ['scheduled', 'sent', 'failed', 'cancelled'] as const
export const reminderStatusSchema = z.enum(REMINDER_STATUSES)
export type ReminderStatus = z.infer<typeof reminderStatusSchema>

export const TRADES = [
  'electrician',
  'plumber',
  'heating',
  'mason',
  'painter',
  'carpenter',
  'service',
  'other',
] as const
export const tradeSchema = z.enum(TRADES)
export type Trade = z.infer<typeof tradeSchema>

export const ORG_ROLES = ['owner', 'member'] as const
export const orgRoleSchema = z.enum(ORG_ROLES)
export type OrgRole = z.infer<typeof orgRoleSchema>

export const ATTACHMENT_KINDS = ['photo', 'video', 'document'] as const
export const ATTACHMENT_TAGS = ['before', 'after', 'team', 'other'] as const

/** Stav zpracování poznámky Buddym (interactions.processing_status; null u interakcí bez AI). */
export const NOTE_PROCESSING_STATUSES = [
  'pending',
  'transcribing',
  'extracting',
  'done',
  'failed',
] as const
export const noteProcessingStatusSchema = z.enum(NOTE_PROCESSING_STATUSES)
export type NoteProcessingStatus = z.infer<typeof noteProcessingStatusSchema>

/** Zdroj přepisu hlasovky (SPEC část 6): device = rozpoznávání v telefonu nebo prohlížeči. */
export const TRANSCRIPT_SOURCES = ['device', 'whisper', 'openai', 'mock'] as const
export const transcriptSourceSchema = z.enum(TRANSCRIPT_SOURCES)
export type TranscriptSource = z.infer<typeof transcriptSourceSchema>
